import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { pathOr } from 'ramda';

import { dateToStr } from 'mappers/commonMapper.js'
import XMLFields from './XMLFields';

const generalInfoFieldsXML = [
    { name: "VERREK_1.Employee", label: 'Employee' },
    { name: "VERREK_1.Candidate", label: 'Candidate' },
    { name: "VERREK_1.CLIENTFIO", label: 'CLIENTFIO_FORM' },
    { name: "VERREK_1.CLIENTCOMP", label: 'CLIENTCOMP' },
    { name: "VERREK_1.REKOMFIO", label: 'REKOMFIO' },
    { name: "VERREK_1.REKOMCOMP", label: 'REKOMCOMP' },
    { name: "VERREK_1.REKOMDOLG", label: 'REKOMDOLG' },
    { name: "VERREK_1.REKOMPHONE", label: 'REKOMPHONE' },
];

const collaborationPeriodFieldsXML = [
    { name: "VERREK_1.HOWLONGKNOW", label: 'HOWLONGKNOW' },
    { name: "VERREK_1.WHENWORK", label: 'WHENWORK' },
    { name: "VERREK_POS.REKNAME", label: 'REKNAME' },

];

const subordinationSystemFieldsXML = [
    { name: "VERREK_1.WASREKCHIEF", label: 'WASREKCHIEF' },
    { name: "VERREK_1.WHATREKOTN", label: 'WHATREKOTN' },
    { name: "VERREK_1.YOUDECIDEPRIM", label: 'YOUDECIDEPRIM_FORM' },
    { name: "VERREK_1.HOWLONGSTART", label: 'HOWLONGSTART' },
];

const mainTasksFieldsXML = [
    { name: "VERREK_POS.WHATTASK", label: 'WHATTASK' },
    { name: "VERREK_POS.WHATFUNC", label: 'WHATFUNC' },

];

const workResultsFieldsXML = [
    { name: "VERREK_HOWWORK.MARK", label: 'MARK' },
    { name: "VERREK_HOWWORK.ACHIEVE", label: 'ACHIEVE' },
    { name: "VERREK_HOWWORK.VKLAD", label: 'VKLAD' },
    { name: "VERREK_HOWWORK.RESULT", label: 'RESULT' },
    { name: "VERREK_HOWWORK.CMPRESULT", label: 'CMPRESULT' },
];

const strengthsFieldsXML = [
    { name: "VERREK_PART.STRONG", label: 'STRONG_FORM' },
];

const peopleManagementFieldsXML = [
    { name: "VERREK_3.WASCHIEF", label: 'WASCHIEF' },
    { name: "VERREK_3.WHATCHIEF", label: 'WHATCHIEF' },
    { name: "VERREK_3.WASSAMOST", label: 'WASSAMOST' },
    { name: "VERREK_3.WASTRUDO", label: 'WASTRUDO' },
];

const weakSidesFieldsXML = [
    { name: "VERREK_HOWWORK.DIF", label: 'DIF' },
    { name: "VERREK_PART.NOTSTRONG", label: 'NOTSTRONG' },
];

const peopleRelationshipsFieldsXML = [
    { name: "VERREK_3.WITHCHIEF", label: 'WITHCHIEF' },
    { name: "VERREK_3.WITHKOLLEGA", label: 'WITHKOLLEGA' },
    { name: "VERREK_3.WITHOUT", label: 'WITHOUT' },
];

const workAttitudeFieldsXML = [
    { name: "VERREK_HOWWORK.HOWWORK", label: 'HOWWORK' },
    { name: "VERREK_HOWWORK.WHYSTESS", label: 'WHYSTESS' },
    { name: "VERREK_HOWWORK.WHATOUTFAKTOR", label: 'WHATOUTFAKTOR' },
    { name: "VERREK_HOWWORK.STIMUL", label: 'STIMUL' },
];

const futurеLeaderFieldsXML = [
    { name: "VERREK_4.WHATFUTURECHIEF", label: 'WHATFUTURECHIEF' },
];

const leavingReasonsFieldsXML = [
    { name: "VERREK_4.WHYGO", label: 'WHYGO' },
    { name: "VERREK_4.WHUWILLGO", label: 'WHUWILLGO' },
];

const desireAgainWorkFieldsXML = [
    { name: "VERREK_4.WANTHIMCOMMENT", label: 'WANTHIMCOMMENT_FORM' },
    { name: "VERREK_4.WANTHIMKOLLEGA", label: 'WANTHIMKOLLEGA_FORM' },
]

const futureWorkComplianceFieldsXML = [
    { name: "VERREK_4.WHYYOUREKOM", label: 'WHYYOUREKOM' },
];

const candidateAdditionalinfoFieldsXML = [
    { name: "VERREK_4.ADDINFORM", label: 'ADDINFORM' },
];

const yourAdditionalQuestionFieldsXML = [
    { name: "VERREK_4.ADDQUESTION", label: 'ADDQUESTION' },
];

export default class VerificateRecomendation extends Component {
    componentDidMount() {
        const { event } = this.props;

        if (event && event.details) {
            const { details } = event;

            setTimeout(() => {
                this.props.form.change('result.xmlbody.VERREK_1.CANDKEY', pathOr('', ['people', 0, 'id'], details));
                this.props.form.change('result.xmlbody.VERREK_1.Candidate', pathOr('', ['people', 0, 'text'], details));
                this.props.form.change('result.xmlbody.VERREK_1.WHOCREATEKEY', pathOr('', ['responsible', 0, 'id'], details));
                this.props.form.change('result.xmlbody.VERREK_1.Employee', pathOr('', ['responsible', 0, 'text'], details));
                this.props.form.change('result.xmlbody.VERREK_1.REKOMFIO', pathOr('', ['contact', 0, 'text'], details));
                this.props.form.change('result.xmlbody.VERREK_1.REKOMCOMP', pathOr('', ['company', 0, 'text'], details));
                this.props.form.change('result.xmlbody.VERREK_1.REKOMDOLG', pathOr('', ['otdelname'], event));
                this.props.form.change('result.xmlbody.VERREK_1.VERREKDATE', dateToStr(details.eventDate));
            }, 0)
        }
    }

    render() {
        return (
            <div>
                <Translate content="xml.PplVerRek.generalInfo" component='h3' />
                <XMLFields fieldsXML={generalInfoFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.collaborationPeriod" component='h3' />
                <XMLFields fieldsXML={collaborationPeriodFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.subordinationSystem" component='h3' />
                <XMLFields fieldsXML={subordinationSystemFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.mainTasks" component='h3' />
                <XMLFields fieldsXML={mainTasksFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.workResults" component='h3' />
                <XMLFields fieldsXML={workResultsFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.strengths" component='h3' />
                <XMLFields fieldsXML={strengthsFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.peopleManagement" component='h3' />
                <XMLFields fieldsXML={peopleManagementFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.weakSides" component='h3' />
                <XMLFields fieldsXML={weakSidesFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.peopleRelationships" component='h3' />
                <XMLFields fieldsXML={peopleRelationshipsFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.workAttitude" component='h3' />
                <XMLFields fieldsXML={workAttitudeFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.futurеLeader" component='h3' />
                <XMLFields fieldsXML={futurеLeaderFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.leavingReasons" component='h3' />
                <XMLFields fieldsXML={leavingReasonsFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.desireAgainWork" component='h3' />
                <XMLFields fieldsXML={desireAgainWorkFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.futureWorkCompliance" component='h3' />
                <XMLFields fieldsXML={futureWorkComplianceFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.candidateAdditionalinfo" component='h3' />
                <XMLFields fieldsXML={candidateAdditionalinfoFieldsXML} translatePrefix="PplVerRek" />
                <Translate content="xml.PplVerRek.yourAdditionalQuestion" component='h3' />
                <XMLFields fieldsXML={yourAdditionalQuestionFieldsXML} translatePrefix="PplVerRek" />
            </div>
        );
    }
}
